import { API_ENDPOINT } from "api/constants";
import TrackingAPI from "api/TrackingAPI";
import axios from "axios";
import { errorAlert } from "ui-kit/Alert";

export const SUBSCRIPTION_PLANS = {
  year: '89.99',
  month: '12.99',
  halfYear: '59.99',
  yearDiscountOffer: '44.99',
  monthDiscountOffer: '2.99',
  month14daysTrialOffer: '0.01',
  trialTest: '0.02'
};

export const getPaymentSession = async (plan: keyof typeof SUBSCRIPTION_PLANS) => {
  const amount = SUBSCRIPTION_PLANS[plan];

  const trackingData = {
    paymentProvider: 'trustpay',
    price: Number(amount)
  };

  TrackingAPI.trackEvent('upgrade_button_click', trackingData);

  try {
    const response = await axios.post(`${API_ENDPOINT}/trustpay/payment-session`, {
      amount: amount,
      is3ds: true,
      returnUrl: window.location.href
    });
    if (response.data.paymentGatewayUrl) {
      window.location.href = response.data.paymentGatewayUrl;
    } else {
      errorAlert('Failed to upgrade');
    }
  } catch (error) {
    errorAlert('Failed to upgrade');
    throw error;
  }
};